import React, { useState, useEffect } from 'react';
import { Button } from '@material-ui/core';
import firebase from 'firebase';
import { storage, db } from './firebase';
import './ImageUpload.css';
import photo from './photo.png';

function ImageUpload({ usercaption, username, useremail }) {
  // const [photo, setPhoto] = useState('');
  // const [progress, setProgress] = useState(0);
  // const [caption, setCaption] = useState('');

  // const handleChange = (e) => {
  //   if (e.target.files[0]) {
  //     setImage(e.target.files[0]);
  //   }
  // };
  console.log('-----ImageUpload:', useremail, username, usercaption);
  // const handleUpload = () => {
  //   if (image) {
  //     const uploadTask = storage.ref(`images/${image.name}`).put(image);
  //     uploadTask.on(
  //       'state_changed',
  //       (snapshot) => {
  //         //progress function
  //         const progress = Math.round(
  //           (snapshot.bytesTransferred / snapshot.totalBytes) * 100
  //         );
  //         setProgress(progress);
  //       },
  //       (error) => {
  //         console.log(error);
  //         alert(error.message);
  //       },
  //       () => {
  //         //complete function
  //         storage
  //           .ref('images')
  //           .child(image.name)
  //           .getDownloadURL()
  //           .then((url) => {
  //             //post image inside db
  //             db.collection('posts').add({
  //               timestamp: firebase.firestore.FieldValue.serverTimestamp(),
  //               caption: caption,
  //               imageUrl: url,
  //               username: username,
  //               useremail: useremail,
  //               imagename: image.name,
  //             });

  //             setProgress(0);
  //             setCaption('');
  //             setImage(null);
  //           });
  //       }
  //     );
  //   } else {
  //     alert('Please choose the file to upload!');
  //   }
  // };

  const addImage = () => {
    document
      .getElementById('files')
      .addEventListener('change', handleChangeFile, false);
    document.getElementById('files').click();
  };
  const handleChangeFile = (e) => {
    if (e.target.files.length) {
      const files = e.target.files;
      imageUpload(files[0]);
    }
  };
  const imageUpload = (image) => {
    if (image) {
      const uploadTask = storage.ref(`images/${image.name}`).put(image);
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          //progress function
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          // setProgress(progress);
        },
        (error) => {
          console.log(error);
          alert(error.message);
        },
        () => {
          //complete function
          storage
            .ref('images')
            .child(image.name)
            .getDownloadURL()
            .then((url) => {
              //post image inside db
              db.collection('posts').add({
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                caption: usercaption,
                imageUrl: url,
                username: username,
                useremail: useremail,
                imagename: image.name,
              });

              // setProgress(0);
              // setCaption('');
              // setPhoto(null);
            });
        }
      );
    } else {
      alert('Please choose the file to upload!');
    }

    // const uploadTask = storage.ref(`avatars/${useremail}-avatar.png`).put(image[0]);
    // uploadTask.on(
    //   'state_changed',
    //   (snapshot) => {
    //     // const progress = Math.round(
    //     //   (snapshot.bytesTransfeered / snapshot.totalBytes) * 100
    //     // );
    //   },
    //   (error) => {
    //     console.log(error);
    //   },
    //   () => {
    //     storage
    //       .ref(`avatars/${useremail}-avatar.png`)
    //       .getDownloadURL()
    //       .then((url) => {
    //         setImage(url);
    //       });
    //   }
    // );
  };
  return (
    <div className='imageupload'>
      {/* <progress className='imageupload_progress' value={progress} max='100' /> */}
      {/* <input
        type='text'
        style={{ fontSize: 16 }}
        placeholder='Enter a caption'
        onChange={(event) => setCaption(event.target.value)}
        value={caption}
      /> */}
      {/* <input type='file' onChange={handleChange} /> */}
      <div style={{ display: 'flex', width: '10%', paddingLeft: '4%' }}>
        <input type='file' id='files' style={{ display: 'none' }} />
        {/* <Button component='label'>
          <Avatar style={{ width: '50px', height: '50px' }} src={image} />
          <button style={{ display: 'none' }} onClick={addImage}></button>
        </Button> */}
        <button
          // variant='contained'
          // color='secondary'
          // size='small'
          // onChange={(event) => setCaption(event.target.value)}
          className='image'
          style={{
            border: '0',
            outLine: '0',
            backgroundColor: 'transparent',
            // paddingLeft: '5px',
            display:'flex'
          }}
          // style={{minWidth:'100px', maxWidth:'120px'}}
          onClick={addImage}>
          <img src={photo} style={{ width: '45%' }} />
          <p style={{paddingTop:'12%', paddingLeft:'7%'}}>Photo/Video</p>
        </button>
      </div>
    </div>
  );
}

export default ImageUpload;
